import { mergeStyleSets } from "@fluentui/react";
import customTheme from "helpers/customTheme";
import PolicyCriteriaEditListItem from "./PolicyCriteriaEditListItem";

const PolicyCriteriaEditListStyles = mergeStyleSets({
  listContainer: {
    height: "calc(100vh - 250px)",
    overflow: "auto",
    borderTop: `1px solid ${customTheme.menuDividerSemanticColor}`,
    paddingTop: 21,
    paddingBottom: 21,
  },
  list: {
    fontSize: 12,
    color: customTheme.bodySubText,
    display: "flex",
    flexWrap: "wrap",
    ".title": {
      width: 180,
      color: customTheme.bodyColor,
      fontSize: 14,
    },
    ".and": {
      fontSize: 10,
      marginTop: "0 !important",
      marginLeft: 7,
      marginBottom: 20,
    },
    ".sub": {
      marginRight: 5,
      width: 56,
      textAlign: "center",
    },
  },
});

export interface IPolicyCriteriaEditListProps {
  constraints: any[];
  onConstraintUpdated: (
    constraint: any,
    constraintIndex: number,
    isRemoved?: boolean
  ) => void;
  disabled?: boolean;
}

function PolicyCriteriaEditList({
  constraints,
  onConstraintUpdated,
  disabled = false,
}: IPolicyCriteriaEditListProps) {
  return (
    <div className={PolicyCriteriaEditListStyles.listContainer}>
      {constraints.map((constraint, index) => (
        <div key={`${constraint.keyId || constraint.id || constraint.key || constraint.name}-${index}`} data-automation-id={index}>
          <PolicyCriteriaEditListItem
            constraint={constraint}
            constraintIndex={index}
            onConstraintUpdated={onConstraintUpdated}
            disabled={disabled}
          />
          {constraints.length !== index + 1 && (
            <div className={PolicyCriteriaEditListStyles.list}>
              <div className="title" />
              <div className="sub and">
                AND
              </div>
            </div>
          )}
        </div>
      ))}
    </div>
  );
}

export default PolicyCriteriaEditList;